import { render, staticRenderFns } from "./SidebarIntent.vue?vue&type=template&id=0f15c7ec&scoped=true&"
import script from "./SidebarIntent.vue?vue&type=script&lang=js&"
export * from "./SidebarIntent.vue?vue&type=script&lang=js&"
import style0 from "./SidebarIntent.vue?vue&type=style&index=0&id=0f15c7ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f15c7ec",
  null
  
)

export default component.exports